import { Md5 } from 'ts-md5';

const md5Hash = (value: string): string => {
    return Md5.hashStr(value);
};

export { md5Hash };
